import apiClient from "./axios";

export const getPettyCashBills = (params) => apiClient.get("/petty-cash/bills", { params }).then(r => r.data);
export const createPettyCashBill = (data) => apiClient.post("/petty-cash/bills", data).then(r => r.data);
export const editPettyCashBill = ({ id, ...data }) => apiClient.patch(`/petty-cash/bills/${id}`, data).then(r => r.data);
export const deletePettyCashBill = (id) => apiClient.delete(`/petty-cash/bills/${id}`).then(r => r.data);
export const payPettyCashBill = (id, data) => apiClient.post(`/petty-cash/bills/${id}/pay`, data).then(r => r.data);